import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "";
export const method = "POST";
export const operationId = "workwearExpressCustomisationPricingEstimateCustomisationPriceV1EstimatePricesPost";
export const path = "/V1/customisationPricing/mine/estimate";
export interface Body {
    estimateRequest: Definitions.WorkwearExpressCustomisationPricingDataEstimateRequestInterface;
}
export type Response = Response200 | Response401 | ResponseDefault;
export type Response200 = Definitions.WorkwearExpressCustomisationPricingDataPriceEstimateInterface;
export type RespKeys = (keyof Definitions.WorkwearExpressCustomisationPricingDataPriceEstimateInterface)[];
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "postJSON">;
export function execute<T extends RespKeys | undefined>(body: Body, effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.WorkwearExpressCustomisationPricingDataPriceEstimateInterface, T[number]>> : Observable<Response200> {
    return effects.postJSON(effects.apiUrl(operationId)(path, undefined, fields), body, effects.restHeaders({})) as any;
}
